import { forwardRef } from 'react';
import { TextField as AriaTextField, TextArea as AriaTextArea } from 'react-aria-components';
import { useController } from 'react-hook-form';
import { Label } from './label';

const UncontrolledTextArea = forwardRef(function Input({ label, className, ...props }, ref) {
  return (
    <AriaTextField {...props} ref={ref} className="flex flex-col gap-1">
      <Label>{label}</Label>
      <AriaTextArea className="w-full px-3 py-2 min-h-30 text-body-dark rounded-md border border-solid border-300 shadow-sm resize-none placeholder:text-light-500 data-[suffix=true]:pr-11  focus-within:ring-1 ring-primary focus:ring-primary focus:border-primary focus-within:border-primary" />
    </AriaTextField>
  );
});

export function TextArea({ name, ...props }) {
  const { field } = useController({ name });
  return <UncontrolledTextArea {...props} {...field} isDisabled={props.disabled} />;
}
